import React, { Component, PropTypes } from 'react';
import { Field } from 'redux-form';
import classnames from 'classnames';
import omit from 'lodash/omit';
import { timeOptions } from 'help/constants';
import {
  TextInputField, EmailInputField, SelectField, RadioButtonField, TextAreaField
} from 'common/components/form_fields';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import { trackGoogle } from 'common/tracking';
import IntercomChat from 'common/containers/intercom_chat';
import { trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME } from 'common/tracking';


export default class Consultation extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    trackGoogle('contact', 'viewed contact form', 'design consultation');
    trackMixpanel(
      MP_VIEWED_MARKETING_PAGE_EVENT_NAME,
      {
        "pageName": "Design consultation",
        "variant": "regular",
      }
    );
  }

  onSubmit(values) {
    trackGoogle('contact', 'submitted contact form', 'design consultation');
    /* only send pertinent information to the server */
    const data = values.via_email? omit(values, ['phone_number', 'best_time_to_call']) : values;
    this.props.onSubmit({ ...data, category: 'consultation' });
  }

  render() {
    const { handleSubmit, isLoading, success, failure, formName, viaEmail, canChat,
      showingChat, toggleChat } = this.props;
    const classes = classnames('help-content contact-page', { succeeded: success, failed: failure });

    return (<div className="l-content help-page" id="content">
      <div className={classes}>
        <Meta
          title="Contact | Help | crowdspring"
          meta={[
            { name: 'description', content: 'How to contact crowdspring - find answers, call, chat or email us, 24/7' },
            { name: 'keywords', content: 'crowdsource, contests, design contests, writing contests, copywriting, design, crowdsourcing' }
          ]}
          link={[{ rel: 'canonical', href: getCanonicalURL('/help/contact/consultation/') }]}
        />
        <div className="row">
          <div className="columns small-16 medium-10 large-12">
            <section className="contact-form">
              <div className="row align-center">
                <div className="small-16 medium-16 large-12 columns">
                  <div className="contact-success">
                    <h3><i className="fa fa-check-circle" /> Message Sent!</h3>
                    <h4>Now what?</h4>
                    <p>
                      A member of our customer support team <i>trained in design
                      consultations</i> will follow-up with you, usually within 24 hours.
                      They will ask specific questions about your goals and concerns for your
                      project and help you understand how crowdspring can help (or recommend
                      other alternatives).
                    </p>
                    <p>
                      In the meantime, find answers to frequently asked questions in our
                      {' '}<a href="/help">Help Center</a>.
                    </p>
                  </div>
                  <div className="contact-failure">
                    <h3><i className="fa fa-exclamation-circle" /> We couldn&apos;t send your message!</h3>
                    <h4>Now what?</h4>
                    <p>
                      Please contact us via phone or chat, while our dev team resolves the issue.
                      You can also find answers to frequently asked questions in our
                      {' '}<a href="/help">Help Center</a>.
                    </p>
                  </div>
                  <form onSubmit={handleSubmit(this.onSubmit)} >
                    <div className="form-intro">
                      <h1>Request a design consultation.</h1>
                      <h3>It&apos;s free and there&apos;s no obligation.</h3>
                      <p>
                        A design expert will contact you shortly to discuss your goals
                        and concerns for your design project and to answer your questions
                        <br className="show-for-large"/> about how crowdspring works.
                      </p>
                      <p>
                        This is not a sales call. We&apos;re here to help you meet your goals
                        <br className="show-for-large"/> and will recommend competitors if
                        we&apos;re not right for your needs.
                      </p>
                    </div>
                    <Field name="full_name" component={TextInputField} label="Full name" />
                    <Field name="via_email" component={RadioButtonField} props={{ value: true }}
                      label="I'd like a Design Consultation by Email" />
                    <Field name="via_email" component={RadioButtonField} props={{ value: false }}
                      label="I'd like a Design Consultation by Phone" />
                    <Field name="email" component={EmailInputField} label="Email" />
                    { !viaEmail &&
                    <Field
                      name="phone_number"
                      component={TextInputField}
                      label="Phone Number"
                      placeholder="+01 555.555.1234"
                    /> }
                    { !viaEmail &&
                    <Field
                      name="best_time_to_call"
                      component={SelectField}
                      label="Best Time to Call"
                      options={timeOptions}
                    /> }
                    <label htmlFor="message">What do you need</label>
                    <Field
                      name="message"
                      component={TextAreaField}
                      rows={5}
                    />
                    {!isLoading && <button
                      className="btn btn-primary"
                      type="submit"
                    >
                      Send
                                   </button>}
                    {isLoading && <button
                      type="button"
                      className="btn btn-primary"
                    >
                      Sending...
                                  </button>}
                  </form>
                </div>
              </div>
            </section>
          </div>
          <aside className="small-16 medium-6 large-4 columns sidebar">

            <section>
              <h4>Customer Support Hours</h4>
              <p>Monday–Friday<br />
              9:00am–5:00pm CT
              </p>
              <ul className="contact-links">
                <li>
                  <a href="tel:877.887.7442" onClick={trackGoogle.bind(null, 'contact', 'clicked phone number', 'design consultation', null, null)} ><i className="fa fa-fw fa-phone" /> 877.887.7442</a>
                </li>
                { canChat &&
                <li>
                  <a onClick={toggleChat}>
                    <i className="fa fa-fw fa-comments-o" /> { showingChat && 'Close' } Chat
                  </a>
                </li> }
              </ul>
            </section>

            <section>
              <h4>Social</h4>
              <ul className="social-links">
                <li>
                  <a href="https://www.facebook.com/crowdspring/" rel="nofollow noopener noreferrer" target="_blank">
                    <i className="fa fa-fw fa-facebook" /> Friend Us
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/crowdspring" rel="nofollow noopener noreferrer" target="_blank">
                    <i className="fa fa-fw fa-twitter" /> Follow @crowdspring
                  </a>
                </li>
              </ul>
            </section>

          </aside>
        </div>
      </div>
      { showingChat && <IntercomChat expandOnShow={true} /> }
    </div>);
  }
}

Consultation.propTypes = {
  viaEmail: PropTypes.bool,
  canChat: PropTypes.bool,
  showingChat: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  toggleChat: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  success: PropTypes.bool,
  formName: PropTypes.string,
};



// WEBPACK FOOTER //
// ./marketing/components/consultation.jsx